import { reportAttachmentReducer } from 'src/modules/report/reducers/reportAttachmentReducer';
import { reportFetchReducer } from 'src/modules/report/reducers/reportFetchReducer';
import { reportGenerateReducer } from 'src/modules/report/reducers/reportGenerateReducer';
import { reportResetReducer } from 'src/modules/report/reducers/reportResetReducer';
import { ReportState } from 'src/modules/report/types/ReportState';
import { chainReducers } from 'src/utils/chainReducers';

const defaultState: ReportState = {
  status: null,
  data: null,
};

export const reportReducer = chainReducers(defaultState, [
  reportFetchReducer,
  reportResetReducer,
  reportGenerateReducer,
  reportAttachmentReducer,
]);
